var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chart",style:(_vm.styleForHeight)},[_c('v-chart',{staticStyle:{"width":"100%"},style:(_vm.styleForHeight),attrs:{"options":_vm.chartOptions,"days":_vm.days,"hours":_vm.hours}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }